import * as React from 'react'
import styled from 'styled-components'
import {
  LeftRightContainer,
  LeftRightItem
} from 'src/components/containers/LeftRight'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import Star from 'src/components/atoms/configurator/Star'
import { media } from 'src/utils.js'
import { StoreProps } from '../../../stores'

const googleTrust = require('src/assets/configurator/google_reviews.png')

interface Props extends StoreProps {
  window?: any
}

export default class CustomerReviews extends React.Component<Props> {
  componentDidMount() {
    this.refreshTrustBadge()
  }

  refreshTrustBadge = () => {
    // eslint-disable-next-line
    // setTimeout(() => window['loadTrustBadge'](), 1500)
  }

  renderReview = (text, author, link) => {
    return (
      <Review>
        <div>
          <Star />
          <Star />
          <Star />
          <Star />
          <Star />
        </div>
        <p>{text}</p>
        <a target='_blank' rel='noopener noreferrer' href={link}>
          {author}
        </a>
      </Review>
    )
  }

  render() {
    return (
      <ConfiguratorBox>
        <h2>Kunden vertrauen uns</h2>
        <LeftRightContainer>
          {this.renderReview(
            '„Ein junges tolles Team mit Herz, wo Einfühlsamkeit und Höflichkeit eine wichtige Rolle spielen.“',
            'Nina G. über Facebook',
            'https://www.facebook.com/pg/benubestattungen/reviews/'
          )}
          {this.renderReview(
            '„Nach der online Planung wird man professionell und menschlich betreut und erlebt bei der Abrechnung keine böse Überraschung.“',
            'Wolf S. über Facebook',
            'https://www.facebook.com/Wolfgang2508/posts/2251295198257739'
          )}
          {this.renderReview(
            '„Engagiertes Team mit sehr gutem Preis-Leistungs-Verhältnis.“',
            'Werner Z. über Google',
            'https://www.google.com/maps/contrib/102952038564048532403/place/ChIJD2HJEQUHbUcRw7T2MrHKu90/@48.2007493,16.3662394,13.03z/data=!4m6!1m5!8m4!1e1!2s102952038564048532403!3m1!1e1'
          )}
        </LeftRightContainer>
        <TrustLogos>
          <img src={googleTrust} width='130' alt='Google' />
        </TrustLogos>
        <TrustLogos>
          <img
            src='https://res.cloudinary.com/dkyl4jbxx/image/upload/w_74,h_74,c_fill,f_auto/v1630548049/zerti_gold_new.png'
            alt='eKomi'
          />
        </TrustLogos>
      </ConfiguratorBox>
    )
  }
}

const Review = styled(LeftRightItem)`
  ${media.giant`
    &:nth-child(odd),
    &:nth-child(even) {
      width: 25%;
      align-items: center;
      text-align: center;
    }
  `}
  ${media.largePhone`
    &:nth-child(odd) {
      width: unset;
      align-items: flex-start;
      text-align: left;
    }
    &:nth-child(even) {
      width: unset;
      align-items: flex-end;
      text-align: right;
    }
  `}

  p,
  a {
    margin-bottom: 3.5px;
  }
`
const TrustLogos = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;

  img {
    margin: 0 5%;
  }
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/CustomerReviews.tsx